// theme.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicStyleService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  applyTheme(themeName: string): void {
    const themePath = `assets/${themeName}/files/${themeName}.css`;    
    const linkEl = this.renderer.createElement('link');
    linkEl.setAttribute('rel', 'stylesheet');
    linkEl.setAttribute('href', themePath);

    // Append to the document head
    this.renderer.appendChild(document.head, linkEl);
  }
}
